export enum ReadOnlyWorkspaceReason {
  Published = "Published",
  Unauthorized = "Unautorized",
}
